<mat-toolbar><span>Edit Time Range</span></mat-toolbar>
<section>
    <mat-dialog-content class="one-column-container">
        <p class="helper-text">
            Choose the start and end time for this range. Use 12-hour format (AM/PM).
        </p>

        <mat-form-field appearance="outline">
            <mat-icon matPrefix>schedule</mat-icon>
            <input matInput
                   [formControl]="start" 
                   placeholder="Start Time" 
                   #startInput 
                   [ngxMatTimepicker]="startPicker" 
                   readonly />
            <ngx-mat-timepicker #startPicker></ngx-mat-timepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-icon matPrefix>schedule</mat-icon>
            <input matInput 
                   [formControl]="end" placeholder="End Time"
                   [ngxMatTimepicker]="endPicker" 
                   readonly />
            <ngx-mat-timepicker #endPicker></ngx-mat-timepicker>
        </mat-form-field>

        <div class="description-message-container" aria-live="polite" *ngIf="errorMessage == ''">
            Selected Time: {{ formattedSelectedRange }}
        </div>

        <mat-error *ngIf="errorMessage != ''">
            <div class="error-message-container">
              {{ errorMessage }}
            </div>
        </mat-error>
    </mat-dialog-content>


    <mat-dialog-actions [align]="'end'">
        <button mat-stroked-button (click)="close()">Cancel</button>
        <button mat-flat-button color="primary" 
                (click)="save()"
                [disabled]="!timeRangeForm.valid || errorMessage != ''">Save</button>
      </mat-dialog-actions>
</section>